/**
 * CSP-safe social share handlers.
 *
 * Replaces the inline onclick attributes that used to live on the share
 * buttons in template-listing.php. Each button carries its share data in
 * data-* attributes; this file wires up the click behaviour so no inline
 * script is required (allowing a strict Content-Security-Policy).
 */
(function () {
    'use strict';

    function fireGaEvent(label) {
        if (!label || typeof window.ga !== 'function') {
            return;
        }
        window.ga('send', {
            hitType: 'event',
            eventCategory: 'Job Detail',
            eventAction: 'click',
            eventLabel: label
        });
    }

    function handleShareClick(button) {
        var social = window.skSocial;
        var data = button.dataset;

        if (social) {
            switch (data.share) {
                case 'twitter':
                    social.getTwitterShareUrl(data.url, data.text);
                    break;
                case 'facebook':
                    social.getFacebookShareUrl(data.url);
                    break;
                case 'linkedin':
                    social.getLinkedInShareUrl(data.url, data.text, data.source);
                    break;
                case 'email':
                    social.getEmailShare(data.url);
                    break;
            }
        }

        fireGaEvent(data.gaLabel);
    }

    function init() {
        var buttons = document.querySelectorAll('.social-share-button');
        for (var i = 0; i < buttons.length; i++) {
            (function (button) {
                button.addEventListener('click', function () {
                    handleShareClick(button);
                });
            })(buttons[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
